import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle } from '../../../../../components/Common/UI/Dialog';
import Icons from '../../../../../components/Common/Icons/Icons';
import { Button } from '../../../../../components/Common/UI/Button';

function NoticesDialog() {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const iframePath = sessionStorage.getItem('iframe-path');

    if (iframePath === '') {
      setModalOpen(true);
      sessionStorage.setItem('iframe-path', '/guidance');
    }
  }, []);

  return (
    <Dialog open={modalOpen} onOpenChange={isOpen => setModalOpen(isOpen)}>
      <DialogContent className="max-h-[98%]">
        <DialogTitle className="flex items-center gap-4 mb-[10px]">
          <Icons.AccountsFilled className="size-[34px]" />
          <p className="text-xl leading-none">Notices that Need Your Attention</p>
        </DialogTitle>

        <p>You have critical eNotices that have not been viewed yet. Please click below to view them.</p>

        <div className="flex justify-end gap-4">
          <Button variant="link" className="py-3 hover:no-underline" onClick={() => setModalOpen(false)}>
            Dismiss
          </Button>
          <Button
            variant="dark"
            className="py-3"
            onClick={() => {
              navigate('/guidance/notices');
              setModalOpen(false);
            }}
          >
            eNotices
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default NoticesDialog;
